import { Grid } from "@mui/material";
import { DocumentCardItem } from "../../../types";
import DocumentCard from "./DocumentCard";

type DocumentCardsListProps = {
    documentCardItems: DocumentCardItem[];
};

export default function DocumentCardsList({
    documentCardItems,
}: DocumentCardsListProps) {
    return (
        <Grid container spacing={2}>
            {documentCardItems.map(
                (documentCardItem: DocumentCardItem, index: number) => {
                    return (
                        <Grid
                            item
                            md={12}
                            sm={6}
                            key={index}
                            sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "1rem",
                                flexDirection: "column",
                                flexShrink: 0,
                                width: "100%",
                            }}
                        >
                            <DocumentCard documentCardItem={documentCardItem} />
                        </Grid>
                    );
                }
            )}
        </Grid>
    );
}
